<template>
  <div style="width: 1000px;position: relative" v-if="tabledata">
    <el-row>
      <el-col :span="24" style="margin-bottom: 20px;margin-top: 20px">
        <span class="title">{{ tabledata.task_title }}</span><span class="title_price">{{
          tabledata.price / 100
        }}元</span>
      </el-col>
      <el-col :span="24" style="margin-bottom: 5px">
        冻结款：￥ {{ tabledata.total_fee / 100 }}元
      </el-col>
      <el-col :span="24" style="margin-bottom: 5px">
        任务ID：{{ tabledata.task_no }}
      </el-col>
      <el-col :span="24" v-if="tabledata.created_at" style="margin-bottom: 5px">
        创建时间：{{ tabledata.created_at }}
      </el-col>
      <el-col :span="24" v-if="tabledata.pay_time" style="margin-bottom: 5px">
        支付时间：{{ tabledata.pay_time }}
      </el-col>
    </el-row>
    <div class="order-info" v-if="tabledata.timeline.length>0">
      <div
          class="btn"
          @click="viewMoreInfo = !viewMoreInfo"
          v-if="job"
      >
        <span v-show="!viewMoreInfo">
          展开
          <i class="el-icon-caret-bottom"></i>
        </span>
        <span v-show="viewMoreInfo">
          收起
          <i class="el-icon-caret-top"></i>
        </span>
      </div>
      <el-row type="flex" justify="start">
        <template v-for="(item, index) in tabledata.timeline">
          <el-col :key="item.id" :span="24" v-show="index === 0 || viewMoreInfo">
            <p :style="{ paddingLeft: index > 0 ? '30px' : '0' }">
              <i v-if="index == 0" style="margin-right:10px;" class="el-icon-bell"></i>
              {{
                `${item.user_name}&nbsp;&nbsp;&nbsp;&nbsp;${item.handle_time}&nbsp;&nbsp;&nbsp;&nbsp;${item.log_text}`
              }}
            </p>
          </el-col>
        </template>
      </el-row>
    </div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="基本信息" name="first">
        <el-row>
          <el-col :span="2" style="margin-bottom: 20px;margin-top: 10px">
            <span class="title_bold">发布企业：</span>
          </el-col>
          <el-col :span="22" style="margin-bottom: 20px;margin-top: 10px">
            <span class="title_bold">{{ tabledata.company_name }}</span>
          </el-col>
          <el-col class="title_bold" style="margin-bottom: 10px" :span="24">
            任务信息
          </el-col>
          <el-row>
            <el-col :span="2" style="margin-bottom: 5px">
              任务分类：
            </el-col>
            <el-col :span="22" style="margin-bottom: 5px">
              {{ tabledata.task_species_name }}
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="2" style="margin-bottom: 5px">
              任务名称：
            </el-col>
            <el-col :span="22" style="margin-bottom: 5px">
              {{ tabledata.task_title }}
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="2" style="margin-bottom: 5px">
              任务介绍：
            </el-col>
            <el-col :span="22" style="margin-bottom: 5px">
              {{ tabledata.task_desc }}
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="2" style="margin-bottom: 5px">
              结算说明：
            </el-col>
            <el-col :span="22" style="margin-bottom: 5px">
              {{ tabledata.settlement_info }}
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="2" style="margin-bottom: 5px">
              任务类型：
            </el-col>
            <el-col :span="22" style="margin-bottom: 5px">
              {{ tabledata.task_type == 1 ? '一次性任务' : '' }}
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="2" style="margin-bottom: 5px">
              任务时长：
            </el-col>
            <el-col :span="22" style="margin-bottom: 20px">
              {{
                tabledata.task_time == 1 ? '5分钟' : tabledata.task_time == 2 ? '15分钟' : tabledata.task_time == 3 ? '30分钟' : tabledata.task_time == 4 ? '60分钟' : '60分钟以上'
              }}
            </el-col>
          </el-row>
          <el-col :span="2" style="margin-bottom: 5px">
            <span class="title_bold">步骤引导</span>
          </el-col>
        </el-row>
        <el-row v-for="(item,index) in guide" :key="index" style="margin-bottom: 20px">
          <el-col :span="1">
            <el-row>
              {{ index + 1 }}
            </el-row>
            <!--            <el-row>-->
            <!--              <div class="line"></div>-->
            <!--            </el-row>-->
          </el-col>
          <el-col :span="23">
            <el-row>
              <el-col style="margin-bottom: 20px">
                {{ item.desc }}
              </el-col>
              <el-col :span="24" style="margin-bottom: 20px" v-if="item.url">
                <el-tag>{{ item.url }}</el-tag>
              </el-col>
              <el-col :span="2">
              </el-col>
              <el-col :span="22" style="margin-bottom: 20px">
                <el-image
                    style="width: 100px; height: 100px;margin-right: 10px"
                    v-for="(uri,idx) in item.images" :key="idx" :src="uri"
                    :preview-src-list="item.images">
                </el-image>
              </el-col>
              <template v-for="(rule,ruleindex) in item.rules">
                <template v-if="rule.type==1">
                  <el-col>
                    ● 需要用户提交规定文字
                  </el-col>
                  <el-col>
                    描述：{{ rule.text }}
                  </el-col>
                </template>
                <template v-if="rule.type==2">
                  <el-col>
                    ● 需要用户提交规定图片
                  </el-col>
                  <el-col>
                    描述：{{ rule.text }}
                  </el-col>
                  <el-col>
                    <el-image
                        style="width: 90px; height: 90px;margin-right: 5px"
                        v-for="(urirule,idxrule) in rule.img" :key="idxrule+''+ruleindex" :src="urirule"
                        :preview-src-list="rule.img">
                    </el-image>
                  </el-col>
                </template>
              </template>
            </el-row>
          </el-col>

        </el-row>
      </el-tab-pane>
      <el-tab-pane label="价格及其他" name="second">
        <el-row>
          <el-col :span="24" style="margin-bottom: 20px;margin-top: 10px">
            <span class="title_bold">价格金额</span>
          </el-col>
          <el-row>
            <el-col style="margin-bottom: 10px" :span="2">
              任务单价：
            </el-col>
            <el-col style="margin-bottom: 10px" :span="22">
              {{ tabledata.price/100 }}元
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="2" style="margin-bottom: 5px">
              任务名额：
            </el-col>
            <el-col :span="22" style="margin-bottom: 5px">
              {{ tabledata.amount }}人
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="2" style="margin-bottom: 5px">
              预付款：
            </el-col>
            <el-col :span="22" style="margin-bottom: 5px">
              {{ tabledata.prepayments / 100 }}
            </el-col>
          </el-row>
          <el-row>
            <el-col class="title_bold" :span="24" style="margin-bottom: 5px;margin-top: 10px">
              结算说明
            </el-col>
            <el-col :span="24" style="margin-bottom: 5px">
              {{ tabledata.settlement_info }}
            </el-col>
          </el-row>
          <el-row>
            <el-col class="title_bold" :span="24" style="margin-bottom: 5px;margin-top: 10px">
              任务联系人
            </el-col>
            <el-col :span="2" style="margin-bottom: 5px">
              {{ tabledata.contract_type == 1 ? '微信' : tabledata.contract_type == 2 ? 'QQ' : 'E-mail' }}
            </el-col>
            <el-col :span="22" style="margin-bottom: 5px">
              {{ tabledata.contract }}
            </el-col>
          </el-row>
          <el-row>
            <el-col class="title_bold" :span="2" style="margin-bottom: 5px;margin-top: 10px">
              投放范围：
            </el-col>
            <el-col :span="22" style="margin-bottom: 5px">
              {{ tabledata.scope }}
            </el-col>
          </el-row>
          <el-row>
            <el-col class="title_bold" :span="24" style="margin-bottom: 5px;margin-top: 10px">
              投放时长
            </el-col>
            <el-col :span="24" style="margin-bottom: 20px">
              {{
                tabledata.online_type == 1 ? '长期投放' : '定期投放'
              }}
            </el-col>
            <el-col :span="24" style="margin-bottom: 20px" v-if="tabledata.online_type == 2">
              截至到{{ tabledata.online_end_time }}
            </el-col>
          </el-row>
          <el-col :span="24" style="margin-bottom: 5px">
            <span class="title_bold">设备限制</span>
          </el-col>
          <el-col :span="24" style="margin-bottom: 5px">
            <span>{{ tabledata.device_limit == 1 ? '全部' : tabledata.device_limit == 2 ? 'IOS' : '安卓' }}</span>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>
    <div style="text-align: center" v-if="examine">
      <el-button type="primary" @click="adopt(true)"><i class="el-icon-circle-check"></i> 审核通过</el-button>
      <el-button type="warning" @click="adopt(false)"><i class="el-icon-circle-close"></i> 拒绝</el-button>
    </div>
    <el-dialog
        width="30%"
        title="请输入拒绝原因"
        :visible.sync="innerVisible"
        append-to-body>
      <el-input
          type="textarea"
          :rows="2"
          placeholder="请输入内容"
          v-model="textarea">
      </el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click="innerVisible = false">取 消</el-button>
        <el-button type="primary" @click="adoptfail">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import "../../../../shared/plugins/element"
import Api from "@/api";

export default {
  name: "jobTaskDetail",
  props: {
    order_id: null,
    examine: null
  },
  data() {
    return {
      textarea: "",
      innerVisible: false,
      job: undefined,
      viewMoreInfo: false,
      activeName: 'first',
      guide: [],
      tabledata: undefined
    };
  },
  components: {},
  computed: {},
  created() {
  },
  watch: {
    order_id() {
      this.gettabdata();
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.gettabdata();
    },
    async gettabdata() {
      this.tabledata = await Api.post.getMoneytask({
        id: this.$route.params.id || this.order_id
      });
      console.log(123123213)
      if (this.tabledata) {
        this.guide = this.tabledata.task_step_guide_data
      }
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    adopt(data) {
      if (data) {
        this.$confirm('确认审核通过吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          try {
            Api.post.moneyreview({
              id: this.$route.query.order_id || this.order_id,
              review_result: 10
            }).then(() => {
              this.$emit('adopt', false)
              this.getData();
              this.$message({
                type: 'success',
                message: '审核通过!'
              });
            });
          } catch (e) {
            console.log(e)
            this.$message.error('请检查网络');
          }
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消审核'
          });
        });
      } else {
        this.innerVisible = true
      }
    },
    adoptfail() {
      try {
        Api.post.moneyreview({
          id: this.$route.query.order_id || this.order_id,
          review_result: 20,
          review_reject_reason: this.textarea
        }).then(() => {
          this.innerVisible = false;
          this.$emit('adopt', false)
          this.$message({
            type: 'success',
            message: '已拒绝!'
          });
        });
      } catch (e) {
        console.log(e)
        this.$message.error('请检查网络');
      }
    },
  }
};
</script>
<style lang="scss" scoped>
.title {
  font-weight: bold;
  font-size: 16px;
}

.title_bold {
  font-weight: bold;
}

.title_price {
  font-size: 16px;
  color: #DC162F;
  margin-left: 20px;
}

.order-info {
  margin: 10px 0 38px;
  border: 1px solid #35b5fe;
  background: rgb(224, 244, 255);
  padding: 15px 20px 2px;
  position: relative;

  .btn {
    cursor: pointer;
    z-index: 10;
    position: absolute;
    right: 10px;
  }

  .reason {
    color: rgb(238, 88, 88);
    padding-left: 30px;
  }
}

.line {
  width: 1px;
  height: 100px;
  background: #000000;
}
</style>
